export const CAMPAIGN_TARGETS = 'Targets';
export const SAMPLE_LABEL = 'Sample';
export const WEIGHTED_HEADER_LABEL = 'Weighted (000)';
export const PERCENT = 'Percent';
export const LAST_MODIFIED = 'Last Modified';
export const DISTRIBUTION_REQUESTED = 'Distribution Status';
export const TAGS = 'Tags';
export const SAMPLE_SIZE_THRESHOLD = '1,000';
export const DATA_ENABLEMENT = 'DATA_ENABLEMENT';
export const TEXT_FIELD = 'Text field';
export const DROPDOWN = 'Dropdown';
export const PASSWORD = 'Password Field';
export const USERNAME = 'Username field';
export const DATAHUB_BUILD_MODULE = 'DATAHUB_BUILD';

// warning messages
export const LOW_SAMPLE_WEIGHTED_MSG = {
  title: 'Sample size below threshold',
  message: `The definitions highlighted below have a sample size below
                  the recommended threshold of ${SAMPLE_SIZE_THRESHOLD} or more respondents.
                  Please consider modifying or choosing an alternative definition.`,
  type: 'warning',
};

export const MORE_STUDY_AVAILABLE_MSG = {
  title: 'More current study available',
  message: `A more recent version of your selected study is available for one or more
                  of the below definitions. Please consider updating your study.`,
  type: 'warning',
};

export const IMPORT_SUCCESS_MSG = {
  title: 'Success!',
  message: `imported to your target list.`,
  type: 'success',
};

export const IMPORT_ERROR_MSG = {
  title: "Name already exists",
  message: `To complete action, enter a unique name.`,
  type: 'error',
};

// export const statusList = ['Submitted', 'Processing', 'Approval Required', 'Active', 'Deactivated', 'Cancelled']
export const STATUS_LIST = ['Draft', 'Submitted', 'Processing'];
export const START_DATE_DISABLED_STATUS = [
  'Active',
  'Deactivated',
  'Cancelled',
];
export const END_DATE_DISABLED_STATUS = ['Deactivated', 'Cancelled', 'Active'];
export const DISTRIBUTE_DISABLED_IN_EDIT = [
  'Submitted',
  'Processing',
  'Approval Required',
  'Active',
];
export const DISTRIBUTE_CANCEL_STATUS = [
  'Submitted',
  'Processing',
  'Approval Required',
];

export const DE_BUILD_DUPLICATE_NAME_ERROR = 'Name already exists. To move to Preview, enter a unique name.';

export const ACT_ACCOUNTID_CHECK = [5580] // Specific handling for Free Wheel Account
